<template>

  <v-container fluid v-if="suppliers">

    <im-page-title
      title="Listă Furnizori"
    />

    <im-suppliers-toolbar
      :query.sync="query"
      @create="goToCreate"
    />

    <div class="ma-3">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-suppliers-list
      :suppliers="suppliers"
      :pagination.sync="pagination"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import _ from 'lodash';
  import repository from '@/repositories/supplier-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-suppliers-toolbar': () => import('@/components/Supplier/SupplierToolbar'),
      'im-suppliers-list': () => import('@/components/Supplier/SupplierList')
    },

    data: () => ({
      suppliers: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchSuppliersDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchSuppliers',
        immediate: false
      }
    },

    methods: {

      fetchSuppliersDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchSuppliers()
      }, 300),

      async fetchSuppliers() {
        try {
          this.querying = true;
          this.suppliers = await repository.getSuppliers(this.query, this.pagination);
        } catch (e) {
        } finally {
          this.querying = false;
        }
      },

      goToCreate() {
        this.$router.push('/suppliers/create');
      }

    }
  }

</script>